import React, { useState } from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Text,
} from '@chakra-ui/react';
import { ordersByEmail } from '../api';
// MOSTRA UN MODAL DI RICHIESTA DI INSERIMENTO EMAIL CON
// TITLE, BODY
// Opzionale children
// Opzionale un pulsante di cancel se passi onCancel
// Opzionale url che viene associato al pulsante OK

export const ModalInfoWithEmail = ({
  title,
  body,
  isOpen,
  onClose,
  onCancel,
  selectedDate,
  children,
}) => {
  // const [isLoading, setIsLoading] = React.useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleChange = (event) => {
    setError('');
    setEmail(event.target.value);
  };

  const hasCancelButton = !!onCancel;

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          {body}
          <Input
            my={5}
            value={email}
            onChange={handleChange}
            placeholder='email@email.com'
            size='sm'
          />
          {children}
          <Text color='tomato'>{error}</Text>
        </ModalBody>
        <ModalFooter>
          {hasCancelButton && (
            <Button
              minWidth={125}
              size={'lg'}
              mr={3}
              onClick={() => {
                setError('');
                onCancel();
              }}
            >
              Annulla
            </Button>
          )}
          <Button
            minWidth={125}
            size={'lg'}
            mr={3}
            isDisabled={!email}
            onClick={async () => {
              setError('');
              const data = await ordersByEmail(email);
              //   console.log(data.orders);
              const isMatch = data.orders.some((order) => {
                const dateA = new Date(selectedDate);
                const dateB = new Date(order.selectedDate);
                // console.log('DATE A', dateA);
                // console.log('DATE B', dateB);
                return dateA.valueOf() === dateB.valueOf();
              });
              if (isMatch) {
                onClose(isMatch);
                setError('');
                return;
              }
              setError('Nessun ordine corrispondente a questa mail per la data selezionata');
              //   onClose(email);
              //   setEmail('');
            }}
          >
            OK
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
